<i18n lang="json">
{
  "en": {
    "serviceTerms": {
      "title": "Terms",
      "url": "{rvezyMarketplaceUrl}/en/c/terms-and-conditions"
    },
    "privacyPolicy": {
      "title": "Privacy",
      "url": "{rvezyMarketplaceUrl}/en/c/privacy-policy"
    },
    "partners": {
      "title": "Partners",
      "url": "{rvezyMarketplaceUrl}/en/c/partners"
    },
    "about": "About",
    "aboutUrl": "{rvezyRentalsUrl}/about",
    "affiliates": "Affiliates",
    "affiliatesUrl": "{rvezyRentalsUrl}/affiliates",
    "blog": "Blog",
    "blogUrl": "{rvezyRentalsUrl}/blog",
    "brandGuidelines": "Brand guidelines",
    "careers": "Careers",
    "careersUrl": "{rvezyRentalsUrl}/careers",
    "company": "Company",
    "copyrights": "{currentYear} RVezy. All rights reserved.",
    "downloadRVezyApp": "Download the RVezy App",
    "downloadRVezyAppUrl": "{rvezyRentalsUrl}/app-download",
    "campgrounds": "Search campgrounds",
    "campgroundsUrl": "{rvezyRentalsUrl}/campgrounds",
    "getStarted": "Get started",
    "helpfulLinks": "Helpful links",
    "reviews": "Reviews",
    "reviewsUrl": "{rvezyRentalsUrl}/reviews",
    "rvezyStore": "RVezy Store",
    "rvRentals": "RV rentals",
    "rvRentalsUrl": "{rvezyRentalsUrl}/rv-rentals",
    "guestTitle": "Get the RVezy App",
    "rvsForSale": "RVs for sale",
    "rvsForSaleUrl": "/en/search",
    "sellYourRv": "Sell your RV",
    "sellYourRvUrl": "/en/get-listed/private",
    "applyForFinancing": "Apply for financing",
    "applyForFinancingUrl": "https://v2.digital.dealertrack.ca/creditapp/standalone?token=ddf8a681-cd22-494c-bbe2-f590d26a1538&flow=Full&lang=en"
  },
  "fr": {
    "serviceTerms": {
      "title": "Termes",
      "url": "{rvezyMarketplaceUrl}/fr/c/terms-and-conditions"
    },
    "privacyPolicy": {
      "title": "Confidentialité",
      "url": "{rvezyMarketplaceUrl}/fr/c/privacy-policy"
    },
    "partners": {
      "title": "Partenaires",
      "url": "{rvezyMarketplaceUrl}/fr/c/partners"
    },
    "about": "À propos",
    "aboutUrl": "{rvezyRentalsUrl}/fr/a-propos",
    "affiliates": "Programme d’affiliation",
    "affiliatesUrl": "{rvezyRentalsUrl}/fr/affilies",
    "blog": "Blogue",
    "blogUrl": "{rvezyRentalsUrl}/fr/blogue",
    "brandGuidelines": "Directives de marque",
    "careers": "Carrières",
    "careersUrl": "{rvezyRentalsUrl}/fr/careers",
    "company": "Entreprise",
    "copyrights": "{currentYear} RVezy. Tous droits réservés.",
    "downloadRVezyApp": "Télécharger l’App Rvezy",
    "downloadRVezyAppUrl": "{rvezyRentalsUrl}/fr/telecharger-application",
    "campgrounds": "Rechercher un camping",
    "campgroundsUrl": "{rvezyRentalsUrl}/fr/campings",
    "getStarted": "Pour démarrer",
    "helpfulLinks": "Liens utiles",
    "reviews": "Évaluations",
    "reviewsUrl": "{rvezyRentalsUrl}/fr/evaluations",
    "rvezyStore": "Magasin RVezy",
    "rvRentals": "Locations de VR",
    "rvRentalsUrl": "{rvezyRentalsUrl}/fr/locations-vr",
    "guestTitle": "Téléchargez l'App RVezy",
    "rvsForSale": "VR à vendre",
    "rvsForSaleUrl": "/fr/recherche",
    "sellYourRv": "Vendre votre VR",
    "sellYourRvUrl": "/fr/get-listed/private",
    "applyForFinancing": "Demander un financement",
    "applyForFinancingUrl": "https://v2.digital.dealertrack.ca/creditapp/standalone?token=ddf8a681-cd22-494c-bbe2-f590d26a1538&flow=Full&lang=en"
  }
}
</i18n>

<template>
  <footer class="gap-10 xl:gap-10 py-10 px-0 xl:py-6 xl:px-0 mb-0 caption border-t border-slate-300">
    <!-- Container -->
    <div
      class="grid grid-cols-1 xl:grid-cols-12 gap-y-10 xl:gap-4 w-full m-auto px-4 py-0 sm:max-w-[540px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px] 2xl:max-w-[1440px]"
    >
      <!-- Language switcher -->
      <div
        class="block md:flex gap-3 xl:col-span-6 md:items-center xl:justify-self-end md:justify-between xl:order-2 xl:py-4 xl:px-0"
      >
        <div class="flex gap-3 xl:justify-between">
          <IconStaticCdn name="globe" class="w-4 h-4 a:hover:underline" />
          <AppLangSwitcher class="text-sm font-semibold leading-5 hover:underline capitalize" />
        </div>
        <!-- Download button Small Screen -->
        <div class="inline-flex xl:hidden items-center text-sm gap-2 mt-6 md:mt-0">
          <span class="xl:leading-6 text-sm xl:text-base font-normal">{{ t('guestTitle') }}</span>
          <AppMobileAppDownloadButtons btn-size="medium" />
        </div>
      </div>
      <!-- links -->
      <nav class="grid gap-5 grid-cols-2 md:grid-cols-3 xl:order-4 xl:col-span-8 xl:py-4 xl:px-0">
        <div class="block">
          <h4 class="text-sm m-0 font-semibold">{{ t('company') }}</h4>
          <ul class="mt-1 p-0">
            <li class="list-item" v-for="companyLink in companyLinks" :key="companyLink.text">
              <NuxtLink
                :to="companyLink.url"
                :target="companyLink.target"
                class="hover:underline text-xs/4 xl:text-sm text-[#567390]"
              >
                {{ companyLink.text }}
              </NuxtLink>
            </li>
          </ul>
        </div>

        <div class="block">
          <h4 class="text-sm m-0 font-semibold">{{ t('getStarted') }}</h4>
          <ul class="mt-1 p-0">
            <li class="list-item" v-for="getStartedLink in getStartedLinks" :key="getStartedLink.text">
              <NuxtLink
                :to="getStartedLink.url"
                :target="getStartedLink.target"
                class="hover:underline text-xs/4 xl:text-sm text-[#567390]"
                :prefetch="getStartedLink.prefetch"
              >
                {{ getStartedLink.text }}
              </NuxtLink>
            </li>
          </ul>
        </div>

        <div class="block">
          <h4 class="text-sm m-0 font-semibold">{{ t('helpfulLinks') }}</h4>
          <ul class="mt-1 p-0">
            <li class="list-item" v-for="otherLink in otherLinks" :key="otherLink.text">
              <NuxtLink
                :to="otherLink.url"
                :target="otherLink.target"
                class="hover:underline text-xs/4 xl:text-sm text-[#567390]"
                :prefetch="otherLink.prefetch"
              >
                {{ otherLink.text }}
              </NuxtLink>
            </li>
          </ul>
        </div>
      </nav>
      <!-- Download button -->
      <div
        class="flex flex-col md:flex-row xl:flex-col gap-10 md:gap-0 xl:gap-10 xl:col-span-4 md:justify-between xl:justify-normal xl:py-4 xl:px-0 xl:order-3"
      >
        <div class="hidden xl:block items-center text-sm gap-2">
          <span class="xl:leading-6 text-sm xl:text-base font-normal">{{ t('guestTitle') }}</span>
          <AppMobileAppDownloadButtons btn-size="medium" class="flex gap-1 xl:mt-1" />
        </div>
        <div>
          <ul class="flex gap-6 mt-1 pl-1">
            <li v-for="socialNet in socialNetworkLinks" :key="socialNet.title">
              <a
                :href="socialNet.url"
                :title="socialNet.title"
                :target="socialNet.target"
                class="w-6 h-6 text-blue-500"
              >
                <IconStaticCdn :name="socialNet.icon ?? ''" class="w-6 h-6" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- Copyright -->
      <div class="block md:flex md:items-center xl:col-span-6 xl:order-1 text-xs xl:text-sm xl:py-4 xl:px-0">
        <div class="block xl:flex p-0">
          <p>© {{ t('copyrights', { currentYear: new Date().getUTCFullYear() }) }}</p>
          <div class="block mt-3 xl:ml-6 xl:mt-0">
            <span v-for="(copyrightLink, index) in copyrightLinks" :key="copyrightLink.text">
              <NuxtLink :class="copyrightLink.class" :to="copyrightLink.url">{{ copyrightLink.text }} </NuxtLink>
              <span v-if="index < copyrightLinks.length - 1">|</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
const { t } = useI18n()
const runtimeConfig = useRuntimeConfig()

type LinkDefinition = {
  text?: string
  url: string
  class?: string
  target?: string
  prefetch?: boolean
  title?: string
  icon?: string
}

const socialNetworkLinks: LinkDefinition[] = [
  {
    title: 'Facebook',
    url: 'https://www.facebook.com/rvezy',
    icon: 'facebook',
    target: '_blank'
  },
  {
    title: 'Youtube',
    url: 'https://www.youtube.com/c/RVezy',
    icon: 'youtube',
    target: '_blank'
  },
  {
    title: 'Instagram',
    url: 'https://www.instagram.com/myrvezy',
    icon: 'instagram',
    target: '_blank'
  },
  {
    title: 'Twitter',
    url: 'https://twitter.com/myrvezy',
    icon: 'twitter',
    target: '_blank'
  },
  {
    title: 'Linkedin',
    url: 'https://ca.linkedin.com/company/rvezy.com',
    icon: 'linkedin',
    target: '_blank'
  }
]

const companyLinks = computed((): LinkDefinition[] => {
  return [
    {
      text: t('about'),
      url: t('aboutUrl', {
        rvezyRentalsUrl: runtimeConfig.public.app.rentals.webUrl
      })
    },
    {
      text: t('blog'),
      url: t('blogUrl', {
        rvezyRentalsUrl: runtimeConfig.public.app.rentals.webUrl
      })
    },
    {
      text: t('careers'),
      url: t('careersUrl', {
        rvezyRentalsUrl: runtimeConfig.public.app.rentals.webUrl
      })
    },
    {
      text: t('brandGuidelines'),
      url: 'https://company-209628.frontify.com/d/qwb7VrkogegN',
      target: '_blank'
    },
    {
      text: t('affiliates'),
      url: t('affiliatesUrl', {
        rvezyRentalsUrl: runtimeConfig.public.app.rentals.webUrl
      })
    },
    {
      text: t('reviews'),
      url: t('reviewsUrl', {
        rvezyRentalsUrl: runtimeConfig.public.app.rentals.webUrl
      })
    },
    {
      text: t('rvezyStore'),
      url: 'https://rvezy.store/',
      target: '_blank'
    }
  ]
})

const getStartedLinks = computed((): LinkDefinition[] => {
  return [
    {
      text: t('rvsForSale'),
      url: t('rvsForSaleUrl')
    },
    {
      text: t('sellYourRv'),
      url: t('sellYourRvUrl')
    },
    {
      text: t('applyForFinancing'),
      url: t('applyForFinancingUrl'),
      target: '_blank'
    }
  ]
})

const otherLinks = computed((): LinkDefinition[] => {
  return [
    {
      text: t('rvRentals'),
      url: t('rvRentalsUrl', {
        rvezyRentalsUrl: runtimeConfig.public.app.rentals.webUrl
      }),
      prefetch: true
    },
    {
      text: t('campgrounds'),
      url: t('campgroundsUrl', {
        rvezyRentalsUrl: runtimeConfig.public.app.rentals.webUrl
      })
    },
    {
      text: t('downloadRVezyApp'),
      url: t('downloadRVezyAppUrl', {
        rvezyRentalsUrl: runtimeConfig.public.app.rentals.webUrl
      })
    }
  ]
})

const copyrightLinks = computed((): LinkDefinition[] => {
  return [
    {
      text: t('serviceTerms.title'),
      url: t('serviceTerms.url', { rvezyMarketplaceUrl: runtimeConfig.public.app.marketplace.webUrl }),
      class: 'pr-2 hover:underline'
    },
    {
      text: t('privacyPolicy.title'),
      url: t('privacyPolicy.url', { rvezyMarketplaceUrl: runtimeConfig.public.app.marketplace.webUrl }),
      class: 'px-2 hover:underline'
    },
    {
      text: t('partners.title'),
      url: t('partners.url', { rvezyMarketplaceUrl: runtimeConfig.public.app.marketplace.webUrl }),
      class: 'pl-2 hover:underline'
    }
  ]
})
</script>
